
import { Vue, Options } from "vue-class-component";
@Options({
  props: ["items", "label"]
})
export default class SettingsQuestion extends Vue {
  items!: any;
  label!: any;
  public toggle(event: any) {
    const ref = this.$refs as any;
    ref.menu.toggle(event);
  }
}
